<app-button variant="icon" (click)="goBack()" [attr.aria-label]="ariaLabel" data-testid="back-button">
  <app-icon name="arrow-left" [size]="20" />
</app-button>
